import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "./ui/button";
import { Cookie } from "lucide-react";

const KEY = "xch_cookie_notice"; // "dismissed"

// Global gtag from index.html — pushes `arguments` (the only form gtag.js processes).
const gtag = function () { window.dataLayer = window.dataLayer || []; window.dataLayer.push(arguments); };

/** Cookie notice banner + SPA page_view tracking (GA is always-on, loaded in index.html). */
export default function CookieConsent() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(KEY));
  const location = useLocation();
  const firstPath = useRef(location.pathname + location.search);

  // GA's config call already tracked the initial load; track SPA route changes.
  useEffect(() => {
    const path = location.pathname + location.search;
    if (path === firstPath.current) { firstPath.current = null; return; }
    gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-3 sm:p-4" data-testid="cookie-banner">
      <div className="max-w-2xl mx-auto rounded-2xl border border-border bg-background/95 backdrop-blur-xl shadow-xl p-4 sm:p-5">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-9 h-9 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
              <Cookie className="w-4.5 h-4.5 text-primary" />
            </div>
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
              We use cookies for analytics to improve Xchangely. By continuing to use
              this site you agree to our{" "}
              <Link to="/legal/cookies" className="text-primary underline underline-offset-2" data-testid="cookie-policy-link">
                cookie policy
              </Link>.
            </p>
          </div>
          <Button size="sm" className="rounded-xl shrink-0"
            onClick={() => { localStorage.setItem(KEY, "dismissed"); setDismissed("dismissed"); }}
            data-testid="cookie-accept-btn">
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
}
